import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FexidocLogo } from "@/components/FexidocLogo";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ first_name:"", last_name:"", email:"", password:"" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await signup(f); nav(r?.user?.email_verified ? "/onboarding" : "/verify-pending"); toast.success("Account created. Check your email to verify."); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not create account."); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><Link to="/"><FexidocLogo size={32}/></Link></div>
        <div className="fx-panel p-8">
          <h1 className="font-display text-2xl font-bold text-white">Create your account</h1>
          <p className="text-sm text-slate-400 mt-1">Start building your Fexidoc workspace.</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="signup-form">
            <div className="grid grid-cols-2 gap-3">
              <Field label="First name" value={f.first_name} onChange={(v)=>setF({...f, first_name:v})} testid="signup-first-name"/>
              <Field label="Last name" value={f.last_name} onChange={(v)=>setF({...f, last_name:v})} testid="signup-last-name"/>
            </div>
            <Field label="Work email" type="email" value={f.email} onChange={(v)=>setF({...f, email:v})} testid="signup-email"/>
            <Field label="Password" type="password" value={f.password} onChange={(v)=>setF({...f, password:v})} testid="signup-password"/>
            <div className="text-[11px] text-slate-500 -mt-2">Minimum 10 characters, at least one letter and one digit.</div>
            <button disabled={busy} className="fx-btn-primary w-full text-white font-medium py-2.5 rounded-lg disabled:opacity-60" data-testid="signup-submit">{busy?"Creating…":"Create account"}</button>
          </form>
          <div className="mt-6 text-sm text-slate-400 text-center">Already have an account? <Link to="/login" className="text-cyan-300 hover:text-cyan-200">Sign in</Link></div>
        </div>
      </div>
    </div>
  );
}

function Field({label, value, onChange, type="text", testid}) {
  return (
    <label className="block">
      <div className="text-xs text-slate-400 mb-1">{label}</div>
      <input required type={type} value={value} onChange={(e)=>onChange(e.target.value)} className="w-full bg-[#0D1224] border border-[#1E293B] rounded-lg px-3 py-2 text-sm text-slate-100 focus:border-cyan-400 outline-none" data-testid={testid}/>
    </label>
  );
}
